(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9195],{

/***/ 26245:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog",
      function () {
        return __webpack_require__(9903);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 56952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": function() { return /* reexport */ Select; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-select/dist/react-select.esm.js + 15 modules
var react_select_esm = __webpack_require__(6885);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(52015);
// EXTERNAL MODULE: ./src/@next/components/atoms/ErrorMessage/index.ts + 2 modules
var ErrorMessage = __webpack_require__(98615);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
;// CONCATENATED MODULE: ./src/@next/components/atoms/Select/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 12px;\n  * {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  right: 1rem;\n  transition-duration: 0.3s;\n  transform: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  top: 100%;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var Wrapper = globalStyles/* styled.div */.zo.div(_templateObject(), function(props) {
    return props.theme.typography.smallFontSize;
});
var Indicator = globalStyles/* styled.div */.zo.div(_templateObject1(), function(props) {
    return props.rotate === "true" ? "rotate(180deg)" : "rotate(0deg)";
});
var HelpText = globalStyles/* styled.span */.zo.span(_templateObject2(), function(props) {
    return props.theme.input.labelColor;
}, function(props) {
    return props.theme.typography.smallFontSize;
});
var ErrorMessages = globalStyles/* styled.div */.zo.div(_templateObject3());

;// CONCATENATED MODULE: ./src/@next/components/atoms/Select/Select.tsx









// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
var optionStyle = function(customTheme) {
    return {
        option: function(provided, state) {
            var getBackgroundColor = function() {
                if (state.isSelected) {
                    return customTheme.colors.primaryLight;
                }
                return state.isFocused ? customTheme.colors.primaryTransparent : "white";
            };
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided), {
                alignItems: "center",
                backgroundColor: getBackgroundColor(),
                display: "flex",
                fontWeight: state.isSelected && customTheme.typography.boldFontWeight,
                margin: "0 auto",
                minHeight: "34px",
                verticalAlign: "middle",
                width: "95%"
            });
        }
    };
};
var Select = function(_param) {
    var value = _param.value, onChange = _param.onChange, clearable = _param.clearable, clearValue = _param.clearValue, name = _param.name, options = _param.options, isOptionDisabled = _param.isOptionDisabled, components = _param.components, defaultValue = _param.defaultValue, menuIsOpen = _param.menuIsOpen, customStyles = _param.customStyles, _optionLabelKey = _param.optionLabelKey, optionLabelKey = _optionLabelKey === void 0 ? "label" : _optionLabelKey, _optionValueKey = _param.optionValueKey, optionValueKey = _optionValueKey === void 0 ? "value" : _optionValueKey, errors = _param.errors, props = (0,_object_without_properties/* default */.Z)(_param, [
        "value",
        "onChange",
        "clearable",
        "clearValue",
        "name",
        "options",
        "isOptionDisabled",
        "components",
        "defaultValue",
        "menuIsOpen",
        "customStyles",
        "optionLabelKey",
        "optionValueKey",
        "errors"
    ]);
    var customTheme = react.useContext(styled_components_browser_esm/* ThemeContext */.Ni);
    var handleChange = function(val) {
        if (onChange) {
            onChange(val, name || undefined);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, (0,_object_spread/* default */.Z)({
                className: "custom-select",
                classNamePrefix: "custom-select",
                defaultValue: defaultValue,
                onChange: handleChange,
                value: value,
                // clearValue={clearValue}
                menuIsOpen: menuIsOpen,
                // setMenuIsOpen={setMenuIsOpen}
                menuShouldScrollIntoView: true,
                tabSelectsValue: false,
                getOptionLabel: function(option) {
                    return option[optionLabelKey];
                },
                getOptionValue: function(option) {
                    return option[optionValueKey];
                },
                openMenuOnFocus: true,
                styles: (0,_object_spread/* default */.Z)({}, optionStyle(customTheme), customStyles),
                options: options,
                isOptionDisabled: isOptionDisabled,
                placeholder: "",
                components: components,
                isClearable: clearable
            }, props)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorMessages, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorMessage/* ErrorMessage */.B, {
                    errors: errors
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/@next/components/atoms/Select/index.ts



/***/ }),

/***/ 719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* reexport */ SliceIconBanner; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next-translate-routes/link.js
var next_translate_routes_link = __webpack_require__(73966);
var link_default = /*#__PURE__*/__webpack_require__.n(next_translate_routes_link);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./src/@next/hooks/useMediaQuery/index.ts + 3 modules
var useMediaQuery = __webpack_require__(15996);
// EXTERNAL MODULE: ./src/@next/globalStyles/constants.ts
var constants = __webpack_require__(38408);
// EXTERNAL MODULE: ./src/@prismic/prismic-config.ts + 31 modules
var prismic_config = __webpack_require__(93092);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
// EXTERNAL MODULE: ./src/@next/components/templates/Container/index.ts
var Container = __webpack_require__(95213);
;// CONCATENATED MODULE: ./src/@next/components/slices/SliceIconBanner/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  .slick-slide {\n    .slice-icon-banner__list-item {\n      display: inline-flex !important;\n      justify-content: center;\n      align-items: center;\n      margin: 0;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 30px;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 40px;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 160%;\n  margin-bottom: 50px;\n  color: ",
        ";\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-direction: column;\n    align-items: flex-start;\n    margin: 0 0 -53px;\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  margin: 0 -20px -53px;\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 0 0 53px;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      height: 70px;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      height: 50px;\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin-left: 32px;\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin-left: 24px;\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  align-items: center;\n  margin: 0 20px 53px;\n  ",
        "\n  img {\n    height: 90px;\n    flex-shrink: 0;\n    ",
        "\n    ",
        "\n  }\n  span {\n    font-family: ",
        ";\n    font-size: ",
        ";\n    line-height: 130%;\n    margin-left: 45px;\n    width: auto;\n    max-width: 293px;\n    ",
        "\n    ",
        "\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}


var Wrapper = (0,globalStyles/* styled */.zo)(Container/* Container */.W2)(_templateObject());
var Title = globalStyles/* styled.div */.zo.div(_templateObject3(), function(props) {
    return props.theme.typography.extraFontFamily;
}, function(props) {
    return props.theme.typography.smallFontSize;
}, function(props) {
    return props.theme.colors.graySemi;
}, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject1()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject2()));
var List = globalStyles/* styled.div */.zo.div(_templateObject5(), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject4()));
var Item = globalStyles/* styled.div */.zo.div(_templateObject11(), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject6()), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject7()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject8()), function(props) {
    return props.theme.typography.thinFontFamily;
}, function(props) {
    return props.theme.typography.h4FontSize;
}, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject9()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject10()));

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceIconBanner/SliceIconBanner.tsx










var sliderSettings = {
    arrows: false,
    autoplay: false,
    dots: false,
    infinite: true,
    slidesToScroll: 1,
    slidesToShow: 1,
    speed: 1000
};
function SliceIconBanner(param) {
    var _slice = param.slice, primary = _slice.primary, fields = _slice.fields;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useMediaQuery/* useMediaQuery */.a)("(max-width: ".concat(constants/* smallScreen */.xC, "px)")), 1), isSmallScreen = ref[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        className: "slice-item slice-icon-banner",
        children: [
            (primary === null || primary === void 0 ? void 0 : primary.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                className: "slice-icon-banner__title",
                children: primary === null || primary === void 0 ? void 0 : primary.title
            }),
            isSmallScreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sliderSettings), {
                children: fields === null || fields === void 0 ? void 0 : fields.map(function(item, i) {
                    var title = item.title, img = item.img;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                        as: "div",
                        className: "slice-icon-banner__list-item",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: (img === null || img === void 0 ? void 0 : img.url) || "",
                                alt: "icon"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                dangerouslySetInnerHTML: {
                                    __html: (title === null || title === void 0 ? void 0 : title.replace(/\n/, "<br/>")) || ""
                                }
                            })
                        ]
                    }, "slice-icon-banner-".concat(i));
                })
            })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: Boolean(fields.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
                    className: "slice-icon-banner__list",
                    children: fields === null || fields === void 0 ? void 0 : fields.map(function(item, i) {
                        var title = item.title, img = item.img;
                        var _link = item === null || item === void 0 ? void 0 : item.link;
                        if (item.link) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: (0,prismic_config/* linkResolver */.kG)(_link),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                                    as: "a",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: (img === null || img === void 0 ? void 0 : img.url) || "",
                                            alt: "icon"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            dangerouslySetInnerHTML: {
                                                __html: (title === null || title === void 0 ? void 0 : title.replace(/\n/, "<br/>")) || ""
                                            }
                                        })
                                    ]
                                })
                            }, "slice-icon-banner-".concat(i));
                        }
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                            as: "li",
                            className: "slice-icon-banner__list-item",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: (img === null || img === void 0 ? void 0 : img.url) || "",
                                    alt: "icon"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    dangerouslySetInnerHTML: {
                                        __html: (title === null || title === void 0 ? void 0 : title.replace(/\n/, "<br/>")) || ""
                                    }
                                })
                            ]
                        }, "slice-icon-banner-".concat(i));
                    })
                })
            })
        ]
    });
}
SliceIconBanner.componentName = "iconbanner";

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceIconBanner/index.ts



/***/ }),

/***/ 61514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ mapEdgesToItems; }
/* harmony export */ });
function mapEdgesToItems(data) {
    var ref;
    return (data === null || data === void 0 ? void 0 : (ref = data.edges) === null || ref === void 0 ? void 0 : ref.map(function(param) {
        var node = param.node;
        return node;
    })) || [];
}


/***/ }),

/***/ 32243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ PrismicNextImage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(61608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
// EXTERNAL MODULE: ./node_modules/@prismicio/client/dist/helpers/isFilled.js
var isFilled = __webpack_require__(66686);
// EXTERNAL MODULE: ./src/@next/globalStyles/constants.ts
var constants = __webpack_require__(38408);
;// CONCATENATED MODULE: ./src/@prismic/components/PrismicNextImage/buildURL.ts
/**
 * Converts a camel case string to a param case string.
 *
 * @example
 *
 * ```ts
 * camelCaseToParamCase("fooBar");
 * // => 'foo-bar'
 * ```
 *
 * @param input - Camel case string to convert.
 *
 * @returns Param case version of `input`.
 */ var camelCaseToParamCase = function(input) {
    return input.replace(/[A-Z]/g, function(match) {
        return "-".concat(match.toLowerCase());
    });
};
/**
 * Builds a URL to an Imgix image with Imgix URL API parameters.
 *
 * The given URL must be a full absolute URL containing the protocol and domain.
 *
 * URL parameters already applied to the image will be retained. To remove
 * existing parameters, set the parameter to `undefined` in the `params` argument.
 *
 * @example
 *
 * ```ts
 * const url = buildURL("https://example.imgix.net/image.png", {
 * 	width: 400,
 * });
 * // => https://example.imgix.net/image.png?width=400
 * ```
 *
 * @example
 *
 * ```ts
 * const url = buildURL("https://example.imgix.net/image.png?width=400", {
 * 	height: 300,
 * });
 * // => https://example.imgix.net/image.png?width=400&height=300
 * ```
 *
 * @param url - Full absolute URL to the Imgix image.
 * @param params - An object of Imgix URL API parameters.
 *
 * @returns `url` with the given Imgix URL API parameters applied.
 *
 * @see Imgix URL API reference: https://docs.imgix.com/apis/rendering
 */ var buildURL = function(url, params) {
    var instance = new URL(url);
    Object.keys(params).forEach(function(camelCasedParamKey) {
        var paramKey = camelCaseToParamCase(camelCasedParamKey);
        var paramValue = params[camelCasedParamKey];
        if (paramValue === undefined) {
            instance.searchParams.delete(paramKey);
        } else if (Array.isArray(paramValue)) {
            instance.searchParams.set(paramKey, paramValue.join(","));
        } else {
            instance.searchParams.set(paramKey, "".concat(paramValue));
        }
    });
    // Ensure the `s` parameter is the last parameter, if it exists.
    // @see https://github.com/imgix/imgix-blueprint#securing-urls
    var s = instance.searchParams.get("s");
    if (s) {
        instance.searchParams.delete("s");
        instance.searchParams.append("s", s);
    }
    return instance.toString();
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./src/@prismic/components/PrismicNextImage/buildWidthSrcSet.ts




/**
 * Builds an `<img>` `srcset` attribute value for a given set of widths. It can
 * also optinally apply Imgix URL API parameters to the URLs.
 *
 * The `width` URL parameter will be applied for each `srcset` entry. If a
 * `width` or `w` parameter is provided to the `params` parameter, it will be ignored.
 *
 * @example
 *
 * ```ts
 * const srcset = buildWidthSrcSet('https://example.imgix.net/image.png', {
 * 	widths: [400, 800, 1600],
 * });
 * // => https://example.imgix.net/image.png?width=400 400w,
 * //    https://example.imgix.net/image.png?width=800 800w,
 * //    https://example.imgix.net/image.png?width=1600 1600w
 * ```
 *
 * @example
 *
 * ```ts
 * const srcset = buildWidthSrcSet('https://example.imgix.net/image.png', {
 * 	widths: [400, 800, 1600],
 * 	sat: -100,
 * });
 * // => https://example.imgix.net/image.png?width=400&sat=-100 400w,
 * //    https://example.imgix.net/image.png?width=800&sat=-100 800w,
 * //    https://example.imgix.net/image.png?width=1600&sat=-100 1600w
 * ```
 *
 * @param url - Full absolute URL to the Imgix image.
 * @param params - An object of Imgix URL API parameters. The `widths` parameter
 *   defines the resulting `srcset` widths.
 *
 * @returns A `srcset` attribute value for `url` with the given Imgix URL API
 *   parameters applied.
 */ var buildWidthSrcSet = function(url, _param) {
    var widths = _param.widths, params = (0,_object_without_properties/* default */.Z)(_param, [
        "widths"
    ]);
    return widths.map(function(width) {
        return "".concat(buildURL(url, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params), {
            w: undefined,
            width: width
        })), " ").concat(width, "w");
    }).join(", ");
};

;// CONCATENATED MODULE: ./src/@prismic/components/PrismicNextImage/PrismicNextImage.tsx
/* eslint-disable */ 







var castInt = function(input) {
    if (typeof input === "number" || typeof input === "undefined") {
        return input;
    }
    var parsed = Number.parseInt(input, 10);
    if (Number.isNaN(parsed)) {
        return undefined;
    }
    return parsed;
};
/**
 * Creates a `next/image` loader for Imgix, which Prismic uses, with an optional
 * collection of default Imgix parameters.
 *
 * @see To learn about `next/image` loaders: https://nextjs.org/docs/api-reference/next/image#loader
 * @see To learn about Imgix's URL API: https://docs.imgix.com/apis/rendering
 */ var imgixLoader = function(args) {
    var url = new URL(args.src);
    var params = {
        auto: url.searchParams.getAll("auto") || [
            "format", 
        ],
        fit: url.searchParams.get("fit") || "max",
        w: args.width,
        h: undefined
    };
    if (args.quality) {
        params.q = args.quality;
    }
    return buildURL(args.src, params);
};
/**
 * React component that renders an image from a Prismic Image field or one of
 * its thumbnails using `next/image`. It will automatically set the `alt`
 * attribute using the Image field's `alt` property.
 *
 * It uses an Imgix URL-based loader by default. A custom loader can be provided
 * with the `loader` prop. If you would like to use the Next.js Image
 * Optimization API instead, set `loader={undefined}`.
 *
 * @param props - Props for the component.
 *
 * @returns A responsive image component using `next/image` for the given Image
 *   field.
 * @see To learn more about `next/image`, see: https://nextjs.org/docs/api-reference/next/image
 */ var PrismicNextImage = function(_param) {
    var field = _param.field, _imgixParams = _param.imgixParams, imgixParams = _imgixParams === void 0 ? {} : _imgixParams, alt = _param.alt, fallbackAlt = _param.fallbackAlt, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "field",
        "imgixParams",
        "alt",
        "fallbackAlt"
    ]);
    if (typeof alt === "string" && alt !== "") {
        console.warn('[PrismicNextImage] The "alt" prop can only be used to declare an image as decorative by passing an empty string (alt="") but was provided a non-empty string. You can resolve this warning by removing the "alt" prop or changing it to alt="".');
    }
    if (typeof fallbackAlt === "string" && fallbackAlt !== "") {
        console.warn('[PrismicNextImage] The "fallbackAlt" prop can only be used to declare an image as decorative by passing an empty string (fallbackAlt="") but was provided a non-empty string. You can resolve this warning by removing the "fallbackAlt" prop or changing it to fallbackAlt="".');
    }
    if (isFilled/* imageThumbnail */.S$(field)) {
        var src = buildURL(field.url, imgixParams);
        var url = new URL(src);
        var mediaUrl = new URL("https://images.renodoors.eu/");
        url.hostname = mediaUrl.hostname;
        var ar = field.dimensions.width / field.dimensions.height;
        var resolvedWidth = field.dimensions.width;
        var resolvedHeight = field.dimensions.height;
        if ("width" in restProps || "height" in restProps) {
            var castedWidth = castInt(restProps.width);
            var castedHeight = castInt(restProps.height);
            if (castedWidth) {
                resolvedWidth = castedWidth;
            } else if (castedHeight) {
                resolvedWidth = ar * castedHeight;
            }
            resolvedHeight = resolvedWidth / ar;
        }
        var mobileSrcSet = field["mobile"] ? buildWidthSrcSet(field["mobile"].url, {
            widths: [
                constants/* smallScreen */.xC,
                2 * constants/* smallScreen */.xC
            ]
        }) : null;
        var tabletSrcSet = field["tablet"] ? buildWidthSrcSet(field["tablet"].url, {
            widths: [
                constants/* mediumScreen */.M7,
                2 * constants/* mediumScreen */.M7
            ]
        }) : null;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
            children: [
                mobileSrcSet && /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                    media: "(max-width: ".concat(constants/* smallScreen */.xC, "px)"),
                    srcSet: mobileSrcSet
                }),
                tabletSrcSet && /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                    media: "(max-width: ".concat(constants/* mediumScreen */.M7, "px)"),
                    srcSet: tabletSrcSet
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread/* default */.Z)({
                    src: url.href,
                    width: resolvedWidth,
                    height: resolvedHeight,
                    alt: alt !== null && alt !== void 0 ? alt : field.alt || fallbackAlt,
                    loader: imgixLoader
                }, restProps))
            ]
        });
    }
    return null;
};

;// CONCATENATED MODULE: ./src/@prismic/components/PrismicNextImage/index.ts



/***/ }),

/***/ 9903:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ blog; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./src/@next/utils/maps.ts
var maps = __webpack_require__(61514);
// EXTERNAL MODULE: ./node_modules/@prismicio/react/dist/PrismicRichText.js + 16 modules
var PrismicRichText = __webpack_require__(50385);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react-select/dist/index-baa8dc4f.esm.js + 4 modules
var index_baa8dc4f_esm = __webpack_require__(24969);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
;// CONCATENATED MODULE: ./src/@next/components/atoms/Label/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  display: inline-block;\n  white-space: pre;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Wrapper = globalStyles/* styled.span */.zo.span(_templateObject(), function(props) {
    return props.theme.colors.lightFont;
});

;// CONCATENATED MODULE: ./src/@next/components/atoms/Label/Label.tsx



var Label = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: children
    });
};

;// CONCATENATED MODULE: ./src/@next/components/atoms/Label/index.ts


// EXTERNAL MODULE: ./src/@next/components/atoms/Select/index.ts + 2 modules
var Select = __webpack_require__(56952);
// EXTERNAL MODULE: ./src/@next/hooks/index.ts + 10 modules
var hooks = __webpack_require__(40918);
// EXTERNAL MODULE: ./src/@next/components/atoms/Icon/index.ts + 2 modules
var Icon = __webpack_require__(31484);
;// CONCATENATED MODULE: ./src/@next/components/atoms/DropdownSelect/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: auto;\n  display: flex;\n  flex-direction: column;\n  font-size: ",
        ";\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  padding-bottom: 0.5rem;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  right: 1rem;\n  transition-duration: 0.3s;\n  transform: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var styles_Wrapper = globalStyles/* styled.div */.zo.div(styles_templateObject(), function(props) {
    return props.theme.typography.smallFontSize;
});
var SortLine = globalStyles/* styled.div */.zo.div(_templateObject1());
var Value = globalStyles/* styled.div */.zo.div(_templateObject2());
var Indicator = globalStyles/* styled.div */.zo.div(_templateObject3(), function(props) {
    return props.rotate === "true" ? "rotate(180deg)" : "rotate(0deg)";
});

;// CONCATENATED MODULE: ./src/@next/components/atoms/DropdownSelect/DropdownSelect.tsx











var Control = function(param) {
    var setMenuIsOpen = param.selectProps.setMenuIsOpen, menuIsOpen = param.menuIsOpen, value = param.value;
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SortLine, {
        "data-cy": "dropdown-select-input",
        onClick: function() {
            return setMenuIsOpen(!menuIsOpen);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                children: intl.formatMessage({
                    defaultMessage: "Sort by:",
                    id: "40bnK/"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Value, {
                children: (value === null || value === void 0 ? void 0 : value.label) || ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Indicator, {
                rotate: String(menuIsOpen),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                    name: "select_arrow",
                    size: 10
                })
            })
        ]
    });
};
var IndicatorSeparator = function() {
    return null;
};
var IndicatorsContainer = function() {
    return null;
};
var Option = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_baa8dc4f_esm.c.Option, (0,_object_spread/* default */.Z)({}, props));
};
var DropdownSelect = function(param) {
    var options = param.options, name = param.name, value = param.value, onChange = param.onChange;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), menuIsOpen = ref[0], setMenuIsOpen = ref[1];
    var setElementRef = (0,hooks/* useHandlerWhenClickedOutside */.so)(function() {
        setMenuIsOpen(false);
    }).setElementRef;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Wrapper, {
        "data-cy": "dropdown-select",
        ref: setElementRef(),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* Select */.P, {
            options: options,
            value: value,
            onChange: function(valueProp) {
                setMenuIsOpen(false);
                onChange(valueProp);
            },
            name: name,
            menuIsOpen: menuIsOpen,
            setMenuIsOpen: setMenuIsOpen,
            components: {
                Control: Control,
                IndicatorSeparator: IndicatorSeparator,
                IndicatorsContainer: IndicatorsContainer,
                Option: Option
            }
        })
    });
};

;// CONCATENATED MODULE: ./src/@next/components/atoms/DropdownSelect/index.ts


// EXTERNAL MODULE: ./src/@next/components/molecules/PostsTile/index.ts + 2 modules
var PostsTile = __webpack_require__(21437);
// EXTERNAL MODULE: ./src/@next/components/slices/SliceIconBanner/index.ts + 2 modules
var SliceIconBanner = __webpack_require__(719);
// EXTERNAL MODULE: ./src/@prismic/prismic-config.ts + 31 modules
var prismic_config = __webpack_require__(93092);
;// CONCATENATED MODULE: ./src/images/blog.svg
var blog_namespaceObject = __webpack_require__.p + "static/images/blog.svg";
;// CONCATENATED MODULE: ./src/images/tags-list-bg.png
/* harmony default export */ var tags_list_bg = ({"src":"/_next/static/media/tags-list-bg.3b649de1.png","height":162,"width":48,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAAICAMAAADk895wAAAABlBMVEX///////9VfPVsAAAAAnRSTlNEu741LT0AAAAJcEhZcwAAFiUAABYlAUlSJPAAAAANSURBVHicY2BgZMCGAAB0AAn1FuVEAAAAAElFTkSuQmCC","blurWidth":2,"blurHeight":8});
// EXTERNAL MODULE: ./src/intl.ts
var src_intl = __webpack_require__(72110);
// EXTERNAL MODULE: ./node_modules/next-translate-routes/link.js
var next_translate_routes_link = __webpack_require__(73966);
var link_default = /*#__PURE__*/__webpack_require__.n(next_translate_routes_link);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./src/@prismic/gqlTypes/prismicTypes.tsx
var prismicTypes = __webpack_require__(73518);
// EXTERNAL MODULE: ./src/@next/components/atoms/Button/index.ts + 2 modules
var Button = __webpack_require__(45506);
// EXTERNAL MODULE: ./src/images/chevron_left.svg
var chevron_left = __webpack_require__(36811);
// EXTERNAL MODULE: ./src/images/chevron_right.svg
var chevron_right = __webpack_require__(81111);
;// CONCATENATED MODULE: ./src/views/BlogIndexPage/BlogPostsSlider/styles.ts

function BlogPostsSlider_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 98px;\n  "
    ]);
    BlogPostsSlider_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 77px;\n  "
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 55px;\n  "
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      top: 63%;\n      width: 50px;\n      height: 50px;\n    "
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      top: 30vw;\n      width: 40px;\n      height: 40px;\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      left: -102px;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      left: -5px;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      left: -14px;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      right: -102px;\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      right: -5px;\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      right: -14px;\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 140px;\n  position: relative;\n  ",
        "\n  ",
        "\n  ",
        "\n\n  .slick-arrow {\n    position: absolute;\n    top: 50%;\n    -webkit-transform: translateY(-50%);\n    transform: translateY(-50%);\n    border-radius: 50%;\n    width: 56px;\n    height: 56px;\n    color: transparent;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: contain;\n    box-shadow: 0px 4px 34px rgba(0, 0, 0, 0.08);\n    z-index: 1;\n    ",
        "\n    ",
        "\n  }\n\n  .slick-prev {\n    background-image: url(",
        ");\n    left: -70px;\n    ",
        "\n    ",
        "\n    ",
        "\n  }\n  .slick-next {\n    background-image: url(",
        ");\n    right: -70px;\n    ",
        "\n    ",
        "\n    ",
        "\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-direction: column;\n    padding: 0 67px;\n  "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 0 10px;\n  "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex !important;\n  padding: 0 10px;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 53.5%;\n    margin-right: 58px;\n  "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    margin-right: 0;\n  "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 56.5%;\n  margin-right: 125px;\n  flex-shrink: 0;\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 48vw;\n  "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 60vw;\n  "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 30vw;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 0;\n  "
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 33px;\n    padding: 0 50px;\n  "
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 0;\n    margin-top: 25px;\n  "
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 72px;\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 6px;\n    font-size: 16px;\n  "
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 12px;\n  "
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 10px;\n  font-family: ",
        ";\n  font-style: normal;\n  font-weight: normal;\n  font-size: 18px;\n  line-height: 160%;\n  color: ",
        ";\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      font-size: 30px;\n    "
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      font-size: 24px;\n    "
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  * {\n    font-family: ",
        ";\n    font-style: normal;\n    font-weight: normal;\n    font-size: 36px;\n    line-height: 140%;\n    color: ",
        ";\n    ",
        "\n    ",
        "\n  }\n"
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin-top: 24px;\n      font-size: 16px;\n      line-height: 180%;\n    "
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin-top: 10px;\n      font-size: 14px;\n      line-height: 170%;\n    "
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  p {\n    margin-top: 34px;\n    font-family: ",
        ";\n    font-style: normal;\n    font-weight: normal;\n    font-size: 18px;\n    line-height: 180%;\n    color: #666f73;\n    ",
        "\n    ",
        "\n  }\n"
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 48px;\n    margin-top: 32px;\n  "
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: block;\n    margin: 60px auto 0;\n  "
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 48px;\n    height: 48px;\n  "
    ]);
    _templateObject37 = function _templateObject37() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 68px;\n  margin-top: 74px;\n  span {\n    font-family: ",
        ";\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject38 = function _templateObject38() {
        return data;
    };
    return data;
}




var BlogPostsSlider_styles_Wrapper = globalStyles/* styled.div */.zo.div(_templateObject11(), globalStyles/* media.largeScreen */.BC.largeScreen(BlogPostsSlider_styles_templateObject()), globalStyles/* media.mediumScreen */.BC.mediumScreen(styles_templateObject1()), globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject2()), globalStyles/* media.largeScreen */.BC.largeScreen(styles_templateObject3()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject4()), chevron_left, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject5()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject6()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject7()), chevron_right, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject8()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject9()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject10()));
var Slide = globalStyles/* styled.div */.zo.div(_templateObject14(), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject12()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject13()));
var ImageWrapper = globalStyles/* styled.div */.zo.div(_templateObject18(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject15()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject16()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject17()));
var Image = globalStyles/* styled.div */.zo.div(_templateObject21(), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject19()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject20()));
var TextWrapper = globalStyles/* styled.div */.zo.div(_templateObject25(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject22()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject23()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject24()));
var Tag = globalStyles/* styled.div */.zo.div(_templateObject28(), function(props) {
    return props.theme.typography.extraFontFamily;
}, function(props) {
    return props.theme.colors.graySemi;
}, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject26()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject27()));
var Title = globalStyles/* styled.div */.zo.div(_templateObject31(), function(props) {
    return props.theme.typography.thinFontFamily;
}, function(props) {
    return props.theme.colors.baseFont;
}, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject29()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject30()));
var Description = globalStyles/* styled.div */.zo.div(_templateObject34(), function(props) {
    return props.theme.typography.extraFontFamily;
}, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject32()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject33()));
var ReadButton = (0,globalStyles/* styled */.zo)(Button/* Button */.z)(_templateObject38(), function(props) {
    return props.theme.typography.baseFontFamily;
}, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject35()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject36()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject37()));

;// CONCATENATED MODULE: ./src/views/BlogIndexPage/BlogPostsSlider/BlogPostsSlider.tsx












var BlogPostsSlider = function(param) {
    var featuresPosts = param.featuresPosts;
    var sliderSettings = {
        arrows: true,
        autoplay: false,
        dots: false,
        infinite: true,
        slidesToScroll: 1,
        slidesToShow: 1
    };
    var slider = (0,react.useRef)(null);
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogPostsSlider_styles_Wrapper, {
        className: "featured-slider",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sliderSettings), {
            ref: slider,
            children: featuresPosts && featuresPosts.map(function(post) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Slide, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                style: {
                                    backgroundImage: "url(".concat(post.image.url, ")")
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextWrapper, {
                            children: [
                                post.tags && post.tags.map(function(param) {
                                    var tag = param.tag;
                                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                    var _tag = tag;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
                                        children: _tag.name
                                    }, "featured-slide__".concat(_tag.name));
                                }),
                                post.title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                                        field: post.title
                                    })
                                }),
                                post.preview_description && /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                                        field: post.preview_description
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: (0,prismic_config/* linkResolver */.kG)(post),
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReadButton, {
                                            fullWidth: true,
                                            children: intl.formatMessage(src_intl/* commonMessages.readOn */.i4.readOn)
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }, post.title);
            })
        }))
    });
};

;// CONCATENATED MODULE: ./src/views/BlogIndexPage/BlogPostsSlider/index.ts


;// CONCATENATED MODULE: ./src/views/BlogIndexPage/sortOptions.ts
var sortOptions = {
    firstPublicationDateASC: {
        label: "Earlier first",
        value: "firstPublicationDateASC"
    },
    firstPublicationDateDESC: {
        label: "New first",
        value: "firstPublicationDateDESC"
    }
};

// EXTERNAL MODULE: ./src/@next/components/templates/Container/index.ts
var Container = __webpack_require__(95213);
// EXTERNAL MODULE: ./node_modules/react-svg/dist/react-svg.esm.js + 1 modules
var react_svg_esm = __webpack_require__(98547);
// EXTERNAL MODULE: ./src/images/dropdown-arrow.svg
var dropdown_arrow = __webpack_require__(54543);
;// CONCATENATED MODULE: ./src/views/BlogIndexPage/styles.ts

function BlogIndexPage_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-top: 50px;\n  "
    ]);
    BlogIndexPage_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BlogIndexPage_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-top: 70px;\n  "
    ]);
    BlogIndexPage_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function BlogIndexPage_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-top: 20px;\n  "
    ]);
    BlogIndexPage_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function BlogIndexPage_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        "
    ]);
    BlogIndexPage_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 153px;\n  ",
        "\n  ",
        "\n  ",
        "\n\n  div[data-cy='dropdown-select'] {\n    margin-bottom: 17px;\n    cursor: pointer;\n    font-family: ",
        ";\n    & > div {\n      margin-bottom: 0;\n    }\n  }\n\n  .custom-select {\n    cursor: pointer;\n    & > div:first-of-type {\n      padding: 0;\n      & > span {\n        font-size: ",
        ";\n        line-height: 100%;\n      }\n      & > div:first-of-type {\n        margin: 0 0 0 9px;\n        padding-right: 10px;\n        font-size: ",
        ";\n        line-height: 100%;\n      }\n      & > div:nth-of-type(2) {\n        display: block;\n        width: 15px;\n        height: 15px;\n        background-image: url(",
        ");\n        background-repeat: no-repeat;\n        background-size: contain;\n        background-position: center;\n        ",
        "\n\n        & > svg {\n          display: none;\n        }\n      }\n    }\n\n    &__menu {\n      box-shadow: none;\n    }\n    &__menu-list {\n      font-size: ",
        ";\n      line-height: 100%;\n    }\n    &__option {\n      margin: 0;\n      cursor: pointer;\n      background-color: ",
        ";\n\n      &:hover {\n        color: ",
        ";\n        background-color: rgba(0, 0, 0, 0.1);\n      }\n\n      &--is-selected {\n        font-weight: normal;\n        background-color: ",
        ";\n        &:hover {\n          color: ",
        ";\n          background-color: ",
        ";\n        }\n      }\n    }\n  }\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 75vw;\n  "
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 85vw;\n  "
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    max-width: initial;\n    margin: 0;\n    padding: 0 24px;\n  "
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  font-style: normal;\n  font-weight: normal;\n  text-align: center;\n  letter-spacing: -0.5px;\n  color: ",
        ";\n"
    ]);
    styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: -6px;\n    svg {\n      transform: scale(0.7);\n    }\n  "
    ]);
    styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: -20px;\n    svg {\n      transform: scale(0.5);\n    }\n  "
    ]);
    styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 9px;\n  display: flex;\n  justify-content: center;\n\n  ",
        "\n  ",
        "\n"
    ]);
    styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 100px 0 128px;\n  "
    ]);
    styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 123px 0 132px;\n  "
    ]);
    styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function styles_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 75px 0 65px;\n  "
    ]);
    styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function styles_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 200px 0 200px;\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function styles_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 42px;\n    padding-bottom: 7px;\n    align-items: flex-end;\n  "
    ]);
    styles_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function styles_templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-bottom: 0px;\n    flex-direction: column;\n    align-items: flex-start;\n  "
    ]);
    styles_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function styles_templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  margin-bottom: 60px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-bottom: 10px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n\n  & > img {\n    position: absolute;\n    right: 0;\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    styles_templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function styles_templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-bottom: 40px;\n  "
    ]);
    styles_templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function styles_templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-bottom: 20px;\n  "
    ]);
    styles_templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function styles_templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  padding-bottom: 20px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n  ",
        "\n  ",
        "\n"
    ]);
    styles_templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function styles_templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    grid-gap: 40px 26px;\n    margin-top: 30px;\n  "
    ]);
    styles_templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function styles_templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    grid-template-columns: 1fr 1fr;\n  "
    ]);
    styles_templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function styles_templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    grid-template-columns: 1fr;\n    grid-gap: 16px;\n  "
    ]);
    styles_templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function styles_templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  grid-gap: 60px 40px;\n  margin-top: 40px;\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    styles_templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function styles_templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 31.3%;\n    margin-bottom: 38px;\n  "
    ]);
    styles_templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function styles_templateObject28() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 47.5%;\n\n    &:not(:nth-child(3n)) {\n      margin-right: 0;\n    }\n\n    &:not(:nth-child(2n)) {\n      margin-right: 3.125vw;\n    }\n  "
    ]);
    styles_templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function styles_templateObject29() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 30px;\n    width: 100%;\n\n    &:not(:nth-child(2n)) {\n      margin-right: 0;\n    }\n  "
    ]);
    styles_templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function styles_templateObject30() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 31%;\n  overflow: hidden;\n  margin-bottom: 60px;\n\n  &:not(:nth-child(3n)) {\n    margin-right: 2.02vw;\n  }\n\n  & > a {\n    display: flex;\n    flex-direction: column;\n    justify-content: stretch;\n    height: 100%;\n  }\n  &:hover {\n    box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.07);\n  }\n  &:hover {\n    .post-card__text-side {\n      background-color: #ffffff;\n    }\n  }\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    styles_templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function styles_templateObject31() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 6px;\n    width: 100%;\n    overflow: auto;\n  "
    ]);
    styles_templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function styles_templateObject32() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    styles_templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function styles_templateObject33() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 200vw;\n  "
    ]);
    styles_templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function styles_templateObject34() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        padding: 9px 20px;\n      "
    ]);
    styles_templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function styles_templateObject35() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  ",
        "\n\n  & > li {\n    margin-right: 8px;\n\n    & > button {\n      margin-bottom: 7px;\n      padding: 13px 24px;\n      border-radius: 30px;\n      border: 1px solid rgba(0, 0, 0, 0.1);\n      transition: all 0.25s ease;\n\n      ",
        "\n\n      & > span {\n        font-family: ",
        ";\n        font-size: ",
        ";\n        line-height: 100%;\n        color: ",
        ";\n        font-style: normal;\n        font-weight: normal;\n      }\n\n      &.active {\n        background-color: ",
        ";\n        border-color: ",
        ";\n        transition: all 0.25s ease;\n        & > span {\n          color: ",
        ";\n        }\n      }\n    }\n  }\n"
    ]);
    styles_templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function styles_templateObject36() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 80px 0 30px;\n  "
    ]);
    styles_templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}
function styles_templateObject37() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 70px 0 30px;\n  "
    ]);
    styles_templateObject37 = function _templateObject37() {
        return data;
    };
    return data;
}
function styles_templateObject38() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 40px 0 30px;\n  "
    ]);
    styles_templateObject38 = function _templateObject38() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  border-bottom: 1px solid #cccccc;\n  margin: 100px 0 40px;\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject39 = function _templateObject39() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n"
    ]);
    _templateObject40 = function _templateObject40() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      width: 200px;\n      height: 48px;\n    "
    ]);
    _templateObject41 = function _templateObject41() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      grid-column-start: 1;\n      grid-column-end: none;\n    "
    ]);
    _templateObject42 = function _templateObject42() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &.showmore {\n    width: 320px;\n    height: 68px;\n    font-size: ",
        ";\n    margin: auto;\n    margin-bottom: 32px;\n    grid-column-start: 2;\n    grid-column-end: 2;\n    ",
        "\n    ",
        "\n  }\n"
    ]);
    _templateObject43 = function _templateObject43() {
        return data;
    };
    return data;
}





var BlogIndexPage_styles_Wrapper = globalStyles/* styled.div */.zo.div(styles_templateObject4(), globalStyles/* media.largeScreen */.BC.largeScreen(BlogIndexPage_styles_templateObject()), globalStyles/* media.mediumScreen */.BC.mediumScreen(BlogIndexPage_styles_templateObject1()), globalStyles/* media.smallScreen */.BC.smallScreen(BlogIndexPage_styles_templateObject2()), function(props) {
    return props.theme.typography.baseFontFamily;
}, function(param) {
    var typography = param.theme.typography;
    return typography.baseFontSize;
}, function(param) {
    var typography = param.theme.typography;
    return typography.baseFontSize;
}, dropdown_arrow, globalStyles/* media.largeScreen */.BC.largeScreen(BlogIndexPage_styles_templateObject3()), function(param) {
    var typography = param.theme.typography;
    return typography.baseFontSize;
}, function(props) {
    return props.theme.colors.white;
}, function(props) {
    return props.theme.colors.baseFont;
}, function(props) {
    return props.theme.colors.red;
}, function(props) {
    return props.theme.colors.white;
}, function(props) {
    return props.theme.colors.red;
});
var Content = (0,globalStyles/* styled */.zo)(Container/* Container */.W2)(styles_templateObject8(), globalStyles/* media.largeScreen */.BC.largeScreen(styles_templateObject5()), globalStyles/* media.mediumScreen */.BC.mediumScreen(styles_templateObject6()), globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject7()));
var styles_Title = globalStyles/* styled.div */.zo.div(styles_templateObject9(), function(props) {
    return props.theme.typography.thinFontFamily;
}, function(props) {
    return props.theme.typography.h2FontSize;
}, function(props) {
    return props.theme.typography.h2FontSize;
}, function(props) {
    return props.theme.colors.baseFont;
});
var styles_Icon = (0,globalStyles/* styled */.zo)(react_svg_esm/* ReactSVG */.Q)(styles_templateObject12(), globalStyles/* media.largeScreen */.BC.largeScreen(styles_templateObject10()), globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject11()));
var SliceWrapper = globalStyles/* styled.div */.zo.div(styles_templateObject16(), globalStyles/* media.largeScreen */.BC.largeScreen(styles_templateObject13()), globalStyles/* media.mediumScreen */.BC.mediumScreen(styles_templateObject14()), globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject15()));
var Filters = globalStyles/* styled.div */.zo.div(styles_templateObject19(), globalStyles/* media.largeScreen */.BC.largeScreen(styles_templateObject17()), globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject18()));
var BlogsList = globalStyles/* styled.div */.zo.div(styles_templateObject22(), globalStyles/* media.largeScreen */.BC.largeScreen(styles_templateObject20()), globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject21()));
var List = globalStyles/* styled.div */.zo.div(styles_templateObject26(), globalStyles/* media.largeScreen */.BC.largeScreen(styles_templateObject23()), globalStyles/* media.smMediumScreen */.BC.smMediumScreen(styles_templateObject24()), globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject25()));
var PostTile = globalStyles/* styled.div */.zo.div(styles_templateObject30(), globalStyles/* media.largeScreen */.BC.largeScreen(styles_templateObject27()), globalStyles/* media.mediumScreen */.BC.mediumScreen(styles_templateObject28()), globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject29()));
var TagsWrapper = globalStyles/* styled.div */.zo.div(styles_templateObject32(), globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject31()));
var TagsList = globalStyles/* styled.ul */.zo.ul(styles_templateObject35(), globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject33()), globalStyles/* media.largeScreen */.BC.largeScreen(styles_templateObject34()), function(props) {
    return props.theme.typography.baseFontFamily;
}, function(props) {
    return props.theme.typography.baseFontSize;
}, function(props) {
    return props.theme.colors.baseFont;
}, function(props) {
    return props.theme.colors.red;
}, function(props) {
    return props.theme.colors.red;
}, function(props) {
    return props.theme.colors.white;
});
var BorderDiv = globalStyles/* styled.div */.zo.div(_templateObject39(), globalStyles/* media.largeScreen */.BC.largeScreen(styles_templateObject36()), globalStyles/* media.smMediumScreen */.BC.smMediumScreen(styles_templateObject37()), globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject38()));
var ShowMoreButtonWrapper = globalStyles/* styled.div */.zo.div(_templateObject40());
var ShowMoreButton = (0,globalStyles/* styled */.zo)(Button/* Button */.z)(_templateObject43(), function(props) {
    return props.theme.typography.smallFontSize;
}, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject41()), globalStyles/* media.smMediumScreen */.BC.smMediumScreen(_templateObject42()));

;// CONCATENATED MODULE: ./src/views/BlogIndexPage/Page.tsx














var Page = function(param) {
    var canLoadMore = param.canLoadMore, posts = param.posts, tagsList = param.tagsList, loadMorePosts = param.loadMorePosts, setPostsSorting = param.setPostsSorting, sortBy = param.sortBy, featuresPosts = param.featuresPosts, iconBannerSlice = param.iconBannerSlice, toggleTag = param.toggleTag, clearSelectedTags = param.clearSelectedTags, title = param.title;
    var isAllTopicsShowed = (0,react.useMemo)(function() {
        if (tagsList) {
            return tagsList.every(function(tag) {
                return tag.isActive === false;
            });
        }
        return true;
    }, [
        tagsList
    ]);
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogIndexPage_styles_Wrapper, {
        className: "blog-index",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Icon, {
                    src: blog_namespaceObject
                }),
                title && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Title, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                        field: title
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogPostsSlider, {
                    featuresPosts: featuresPosts
                }),
                iconBannerSlice && /*#__PURE__*/ (0,jsx_runtime.jsx)(SliceWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SliceIconBanner/* SliceIconBanner */.A, {
                        slice: iconBannerSlice
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Filters, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: tags_list_bg.src,
                            alt: ""
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TagsWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TagsList, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: isAllTopicsShowed ? "active" : "",
                                            onClick: clearSelectedTags,
                                            type: "button",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: intl.formatMessage(src_intl/* commonMessages.allTopics */.i4.allTopics)
                                            })
                                        })
                                    }),
                                    tagsList === null || tagsList === void 0 ? void 0 : tagsList.map(function(tag, i) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                className: tag.isActive ? "active" : "",
                                                onClick: function() {
                                                    return toggleTag(tag.tagName);
                                                },
                                                type: "button",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: tag.tagName
                                                })
                                            })
                                        }, "tag_".concat(i));
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownSelect, {
                            options: [
                                sortOptions.firstPublicationDateDESC,
                                sortOptions.firstPublicationDateASC, 
                            ],
                            onChange: setPostsSorting,
                            value: sortBy
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
                    children: posts === null || posts === void 0 ? void 0 : posts.map(function(item) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(PostsTile/* PostsTile */.m, {
                            link: (0,prismic_config/* linkResolver */.kG)(item),
                            image: item.image,
                            title: item.title,
                            tags: item === null || item === void 0 ? void 0 : item.tags.map(function(param) {
                                var tag = param.tag;
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                var _tag = tag;
                                return _tag.name;
                            })
                        }, item._meta.id);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BorderDiv, {}),
                canLoadMore && /*#__PURE__*/ (0,jsx_runtime.jsx)(ShowMoreButtonWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShowMoreButton, {
                        className: "showmore",
                        onClick: loadMorePosts,
                        children: intl.formatMessage(src_intl/* commonMessages.showMore */.i4.showMore)
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var BlogIndexPage_Page = (Page);

;// CONCATENATED MODULE: ./src/views/BlogIndexPage/View.tsx
/* eslint-disable no-unsafe-optional-chaining */ 








var getSortedBlogPosts = function(allPosts, sortByValue, _sortOptions) {
    if (sortByValue === _sortOptions.firstPublicationDateASC.value) {
        // console.log("from old to new ASC");
        var arr = allPosts.sort(function(a, b) {
            var aDate = new Date(a._meta.firstPublicationDate).getTime();
            var bDate = new Date(b._meta.firstPublicationDate).getTime();
            return aDate - bDate;
        });
        return arr;
    }
    if (sortByValue === _sortOptions.firstPublicationDateDESC.value) {
        // console.log("from new to old DESC");
        return allPosts;
    }
    return allPosts;
};
var View = function(param) {
    var data = param.data, seo = param.seo;
    var ref = (0,react.useState)({
        allBlogPosts: null,
        allSortedBlogPosts: null,
        canLoadMore: false,
        postsPerPage: 0,
        postsToShow: null,
        sortBy: sortOptions.firstPublicationDateDESC,
        tagsList: null
    }), state = ref[0], setState = ref[1];
    var allBlogPosts = (0,react.useMemo)(function() {
        return (0,maps/* mapEdgesToItems */.I)(data === null || data === void 0 ? void 0 : data.allBlog_posts).filter(function(item) {
            return (item === null || item === void 0 ? void 0 : item.hide_for_blog_index_nav) !== true;
        });
    }, [
        data
    ]);
    var totalPosts = data === null || data === void 0 ? void 0 : data.allBlog_posts.totalCount;
    var title = data === null || data === void 0 ? void 0 : data.allBlog_homes.edges[0].node.title;
    var iconBannerSlice = (0,react.useMemo)(function() {
        return data === null || data === void 0 ? void 0 : data.allBlog_homes.edges[0].node.body1.find(function(slice) {
            return slice.__typename === "Blog_homeBody1Iconbanner";
        });
    }, [
        data
    ]);
    (0,react.useEffect)(function() {
        setState(function(prev) {
            var ref;
            var postsPerPage = parseInt(data === null || data === void 0 ? void 0 : (ref = data.allBlog_homes) === null || ref === void 0 ? void 0 : ref.edges[0].node.showitemsperpage, 10);
            var tagsList = data === null || data === void 0 ? void 0 : data.allTags.edges.map(function(item) {
                return {
                    isActive: false,
                    tagName: item.node.name
                };
            });
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                allBlogPosts: allBlogPosts,
                allSortedBlogPosts: allBlogPosts,
                canLoadMore: totalPosts > postsPerPage,
                postsPerPage: postsPerPage,
                postsToShow: allBlogPosts === null || allBlogPosts === void 0 ? void 0 : allBlogPosts.slice(0, postsPerPage),
                tagsList: tagsList
            });
        });
    }, [
        data,
        allBlogPosts,
        totalPosts
    ]);
    var loadMorePosts = (0,react.useCallback)(function() {
        setState(function(prev) {
            var ref;
            var postsToShow = (0,_to_consumable_array/* default */.Z)(prev.postsToShow).concat((0,_to_consumable_array/* default */.Z)((ref = prev.allSortedBlogPosts) === null || ref === void 0 ? void 0 : ref.slice(prev.postsToShow.length, prev.postsToShow.length + prev.postsPerPage)));
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                canLoadMore: postsToShow.length < prev.allSortedBlogPosts.length,
                postsToShow: postsToShow
            });
        });
    }, []);
    var setPostsSorting = (0,react.useCallback)(function(value) {
        setState(function(prev) {
            var newAllSortedBlogPosts = prev.allSortedBlogPosts.sort(function(a, b) {
                var aDate = new Date(a._meta.firstPublicationDate).getTime();
                var bDate = new Date(b._meta.firstPublicationDate).getTime();
                if (value.value === "firstPublicationDateASC") {
                    return aDate - bDate;
                }
                if (value.value === "firstPublicationDateDESC") {
                    return bDate - aDate;
                }
                return 0;
            });
            var newPostsToShow = newAllSortedBlogPosts.slice(0, prev.postsToShow.length);
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                allSortedBlogPosts: newAllSortedBlogPosts,
                postsToShow: newPostsToShow,
                sortBy: value
            });
        });
    }, []);
    var featuresPosts = (0,react.useMemo)(function() {
        if (allBlogPosts) {
            return allBlogPosts.filter(function(item) {
                return item.isfeatured === true;
            });
        }
    }, [
        allBlogPosts
    ]);
    var toggleTag = function(tagName) {
        setState(function(prev) {
            var newTagsList = prev.tagsList.map(function(tag) {
                if (tag.tagName === tagName) {
                    return {
                        isActive: !tag.isActive,
                        tagName: tag.tagName
                    };
                }
                return tag;
            });
            if (newTagsList.every(function(t) {
                return t.isActive === false;
            })) {
                var _allSortedBlogPosts = getSortedBlogPosts(prev.allBlogPosts, prev.sortBy.value, sortOptions);
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                    allSortedBlogPosts: _allSortedBlogPosts,
                    canLoadMore: _allSortedBlogPosts.length > prev.postsPerPage,
                    postsToShow: _allSortedBlogPosts.slice(0, prev.postsPerPage),
                    tagsList: newTagsList
                });
            }
            var newAllSortedBlogPosts = prev.allBlogPosts.filter(function(post) {
                // all tags of this post
                var postTags = post.tags.map(function(param) {
                    var tag = param.tag;
                    var _tag = tag;
                    return _tag.name;
                }).join("").toLowerCase();
                return newTagsList.filter(function(t) {
                    return t.isActive === true;
                }).some(function(tag) {
                    return postTags.includes(tag.tagName.toLowerCase());
                });
            });
            var newAllSortedBlogPostsByDate = getSortedBlogPosts(newAllSortedBlogPosts, prev.sortBy.value, sortOptions);
            var newPostsToShow = newAllSortedBlogPosts.slice(0, prev.postsPerPage);
            var newCanLoadMore = newAllSortedBlogPosts.length > prev.postsPerPage;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                allSortedBlogPosts: newAllSortedBlogPostsByDate,
                canLoadMore: newCanLoadMore,
                postsToShow: newPostsToShow,
                tagsList: newTagsList
            });
        });
    };
    var clearSelectedTags = function() {
        setState(function(prev) {
            var newTagsList = prev.tagsList.map(function(tag) {
                return {
                    isActive: false,
                    tagName: tag.tagName
                };
            });
            var newAllSortedBlogPosts = getSortedBlogPosts(prev.allBlogPosts, prev.sortBy.value, sortOptions);
            var newPostsToShow = newAllSortedBlogPosts.slice(0, prev.postsPerPage);
            var newCanLoadMore = newAllSortedBlogPosts.length > prev.postsPerPage;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                allSortedBlogPosts: newAllSortedBlogPosts,
                canLoadMore: newCanLoadMore,
                postsToShow: newPostsToShow,
                tagsList: newTagsList
            });
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, (0,_object_spread/* default */.Z)({}, seo)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogIndexPage_Page, {
                title: title,
                posts: state.postsToShow,
                featuresPosts: featuresPosts,
                tagsList: state.tagsList,
                loadMorePosts: loadMorePosts,
                canLoadMore: state.canLoadMore,
                setPostsSorting: setPostsSorting,
                sortBy: state.sortBy,
                toggleTag: toggleTag,
                clearSelectedTags: clearSelectedTags,
                iconBannerSlice: iconBannerSlice
            })
        ]
    });
};
View.displayName = "BlogIndexPageView";
/* harmony default export */ var BlogIndexPage_View = (View);

;// CONCATENATED MODULE: ./src/views/BlogIndexPage/index.ts


;// CONCATENATED MODULE: ./src/pages/blog/index.ts

var __N_SSG = true;
/* harmony default export */ var blog = (BlogIndexPage_View);


/***/ }),

/***/ 36811:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "static/images/chevron_left.svg";

/***/ }),

/***/ 81111:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "static/images/chevron_right.svg";

/***/ }),

/***/ 54543:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "static/images/dropdown-arrow.svg";

/***/ }),

/***/ 98268:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ asText; }
/* harmony export */ });
const asText = (richTextField, separator = " ") => {
  let result = "";
  for (let i = 0; i < richTextField.length; i++) {
    if ("text" in richTextField[i]) {
      result += (result ? separator : "") + richTextField[i].text;
    }
  }
  return result;
};

//# sourceMappingURL=asText.js.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6885,2962,3537,9945,9774,2888,179], function() { return __webpack_exec__(26245); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);